import type {MediaConfigComponentProps} from '@cohort/merchants/apps';
import {
  FileInput,
  FileInputUploader,
} from '@cohort/merchants/components/form/input/fileInput/FileInput';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {FieldValues} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

const CohortVideoMediaConfigComponent: React.FC<MediaConfigComponentProps> = ({
  customAspectRatio,
  name = 'media',
}) => {
  const {control, register} = useCohortForm<FieldValues>();

  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'medias.video.configComponent',
  });

  return (
    <FileInput
      acceptHint={t('instructionFileInput')}
      assetKind="contentVideo"
      name={`${name}.config.videoFileKey`}
      videoFileConfig={{
        thumbnailOptions: {
          name: `${name}.config.thumbnailFileKey`,
          assetKind: 'contentVideoThumbnail',
        },
      }}
      control={control}
      register={register}
    >
      <FileInputUploader aspectRatio={customAspectRatio} />
    </FileInput>
  );
};

export default CohortVideoMediaConfigComponent;
